import { ImportTypeConfig } from '#/store/hooks/useForms/Import/types/ImportTypeConfig'

export const dairyPlanDiscards: ImportTypeConfig = {
  dateFormat: { default: 'DD/MM/YYYY' },
  instructions: {
    software: 'DairyPlan',
  },
  type: 'dairy-plan-discards',
}
